import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import * as rtApi from '../../components/Api';
import { BackgroundGradient, Loader, Button, SafeAreaView, Alert } from '../../components';
import UserState from '../../src/contexts/UserState';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';
import { CountdownTimer } from '../../components/Projects';

const DisputeInformation = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);
  const [isContractor, setIsContractor] = React.useState(false);
  const [customerContractorText, setCustomerContractorText] = React.useState('contractor');
  const [deadlinePast, setDeadlinePast] = React.useState(false);
  const [dispute, setDispute] = React.useState({});
  const [alertOptions, setAlertOptions] = React.useState({});

  let scrollViewRef = null;
  const linkTo = useLinkTo();

  React.useEffect(() => {
    getAgreement();
  }, []);

  React.useEffect(() => {
    console.log('useEffect isContractor: ', isContractor);
    if (isContractor) {
      setCustomerContractorText('customer');
    }else{
      setCustomerContractorText('contractor');
    }
  }, [isContractor]);

  // React.useEffect(() => {
  //   navigation.setOptions({ title: dispute.title });
  // }, [dispute?.title]);

  const getAgreement = () => {
    setLoading(true);
    rtApi.get(`agreements/${route.params.agreementId}`,)
    .then(data => {
      console.log('getAgreement(): ', data, user, data.agreement.contractor_id === user.id ? true : false);
      setIsContractor(data.agreement.contractor_id === user.id ? true : false)
      if(data.agreement.dispute){
        setDispute(data.agreement.dispute);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/projects`);
    }
  }

  const backToProjects = () => {
    linkTo(`/projects`);
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView ref={ref => scrollViewRef = ref} style={styles.container} contentContainerStyle={styles.innerContainer}>
      {!loading &&
        <>
          <View style={styles.titleContainer}>
            <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>You Filed a Dispute</Text>
            <TouchableOpacity onPress={goBack} style={styles.backArrow}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </TouchableOpacity>
          </View>
        
          {/* <CountdownTimer date={milestone.due_date} freshdeskId={milestone.action_required} setDeadlinePast={setDeadlinePast} /> */}
          <CountdownTimer date={dispute.due_by} freshdeskId='0' setDeadlinePast={setDeadlinePast} type='dispute' message={`Your ${customerContractorText} has 7 days to respond`} />

          <View style={[styles.disputeBox, { marginVertical: 20 }]}>
            <View style={styles.disputeBoxTitle}>
              <Text style={[CS.mediumText, CS.darkText, CS.boldText, CS.centerText]}>The Issue</Text>
            </View>
            <View style={styles.disputeBoxContent}>
              <Text style={[CS.smallText, CS.lightBlueText]}>{dispute.reason}</Text>
            </View>
          </View>

          <View style={[styles.disputeBox, { marginBottom: 20 }]}>
            <View style={[styles.disputeBoxTitle, { backgroundColor: Colors.green }]}>
              <Text style={[CS.mediumText, CS.darkText, CS.boldText, CS.centerText]}>Expectation to Release Funds</Text>
            </View>
            <View style={[styles.disputeBoxContent, {borderColor: Colors.green }]}>
              <Text style={[CS.smallText, CS.lightBlueText, CS.italicText]}>{dispute.expectation}</Text>
            </View>
          </View>
          
          <Text style={[CS.mediumText, CS.lightText, CS.boldText, { marginBottom: 5 }]}>Conceding</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>If your {customerContractorText} does not wish to challenge you or pay the dispute fee, they can concede. {!isContractor ? "By conceding, they agree to fulfill the Expectation to Release Funds (above) and that they will request the funds be released after they have completed the work. This will end the dispute and the project's status will return to In-Progress" : "Conceding will end this dispute and the project's status will return to in-progress"}.</Text>

          <Text style={[CS.mediumText, CS.lightText, CS.boldText, { marginBottom: 5 }]}>Responding To The Dispute</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>If your {customerContractorText} chooses not to concede, they must respond to the dispute. Just as we collected your responses, we need to collect theirs. They’ll have an opportunity to explain their side of the issue as well as upload photos to help demonstrate their view. Your {customerContractorText}'s answers will not be shared with you, just as we won’t share yours.</Text>

          <Text style={[CS.mediumText, CS.lightText, CS.boldText, { marginBottom: 5 }]}>Not Responding</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>If your {customerContractorText} fails to respond within seven (7) days, {!isContractor ? "all remaining money on the project will be refunded to you and the project will be marked completed" : "you will be awarded the money for completing this milestone and the project will resume"}.</Text>

          <Text style={[CS.mediumText, CS.lightText, CS.boldText, { marginBottom: 5 }]}>Dispute Resolution</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If your {customerContractorText} chooses to respond to the dispute, you both will, separately, receive an email that will allow you to self-schedule a one-on-one phone call with our dispute resolution negotiators.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Our dispute resolution negotiator will dedicate up to three (3) hours of their time to work with both parties to reach an agreeable compromise. This may involve, for example, encouraging the contractor to revoke their payment request, complete additional work, and then re-request releasing the money. It may involve reminding the homeowner that absolute perfection is unattainable. Or, it could be somewhere in the middle. In any event, both you and your {customerContractorText} will need to agree.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If an agreement is reached, the dispute resolution negotiator will walk one party through the necessary steps to implement the new understanding and the project can resume as it did before the dispute.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>If the dispute resolution negotiator cannot reach an agreement between you and your {customerContractorText}, or either side feels the effort of this process is futile, they can escalate the dispute to court/arbitration.</Text>
          
          <Text style={[CS.mediumText, CS.lightText, CS.boldText, { marginBottom: 5 }]}>Court/Arbitration</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>If the dispute is escalated to court/arbitration, Renovation Trust will cease to mediate the matter. Renovation Trust will only follow the directions of a court judgement or arbitrator - neither you nor your {customerContractorText}. It is the responsibility of either you or your {customerContractorText} to file a lawsuit in a court of law or make arrangements with an arbitrator. Those arrangements are beyond the services provided by Renovation Trust. Our role will simply be to hold the disputed funds until a determination is made.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>You are encouraged to directly resolve any disputes you may have with your {customerContractorText} - it is the quickest and, by far, cheapest method. Dispute resolution will cost each party $89 and can last a number of weeks. Going to court or arbitration can cost thousands of dollars and take months or even years.</Text>

          <Button text='Back To Projects' onPress={() => backToProjects} style={styles.button} />
        </>
      }
      </KeyboardAwareScrollView>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  innerContainer: {
    width: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: 10,
  },
  titleContainer: {
    marginVertical: 20,
    alignItems: 'center',
  },
  backArrow: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
  intro: {
    marginBottom: 20,
  },
  question: {
    marginBottom: 10,
  },
  answer: {
    height: 80,
  },
  button: {
    marginBottom: 20,
  },
  disputeBox: {
    borderRadius: 10,
  },
  disputeBoxTitle: {
    padding: 10,
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  disputeBoxContent: {
    padding:10,
    backgroundColor: Colors.textInputBackground,
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 1,
    borderColor: Colors.yellow,
  },
});

export default DisputeInformation;